import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_DOMAIN_USERS = 'FETCH_ANALYTIC_DOMAIN_USERS';
export const fetchAnalyticDomainUsersAction = createAction(FETCH_ANALYTIC_DOMAIN_USERS);